export default "__VITE_ASSET__c3f18755__"